module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_repair.section.event":"รายละเอียดปัญหา","service_repair.section.repair":"การซ่อม","service_repair.section.result":"ผลการซ่อม","service_repair.section.parts":"รายการอะไหล่งานซ่อม","service_repair.section.inspection":"ข้อมูลตรวจสอบหลังซ่อม"}}')
  delete Component.options._Ctor
}
